/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
  Box,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import { lightGreen } from "@mui/material/colors";
import styled from "@emotion/styled";
import RetrunFindCoupon from './ReturnFindCoupon';
import get_token from "../lib/get_token";
import ReturnEditDetail from "./ReturnEditDetail";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Container = styled(Box)`
  padding: 10px;
`;

const CouponContainer = styled(Box)`
  display: flex;
  margin-top: 10px;
  align-items: center;
`;

// 등록하기 팝업
function ReturnEdit(props) {
  const { openEdit, setOpenEdit, login, load_data, seq } = props;
  const token = localStorage.getItem("token");
  const [mb_name, setMbName] = useState('');
  const [openFindCoupon, setOpenFindCoupon] = useState(false); // 쿠폰찾기 팝업
  const [coupon, setCoupon] = useState({
    seq: 0,
    name: '',
    mcd: '',
  });
  const title = '쿠폰반환';
  const [reason, setReason] = useState('');
  const [reason_etc, setReasonEtc] = useState('');
  const [file, setFile] = useState(null);
  const [image, setImage] = useState('');
  const [state, setState] = useState(''); 
  const [return_coupon_count, setReturnCouponCount] = useState(0);
  const [tmcd, setTmcd] = useState('');
  const [manager, setManager] = useState(''); // 1
  const [tcid, setTcid] = useState('');


  const onSubmit = async () => {

    const formData = new FormData();
    // if (file === null) {
    //   Swal.fire('오류', '업로드할 이미지를 선택하세요.');
    //   return;
    // }
    // 수정시는 이미지 첨부 필수 아님

    formData.append('mcd', coupon.mcd); // 3
    formData.append('cid', login.cid);
    formData.append('level', login.level);
    formData.append('file', file);
    formData.append('seq', seq);
    formData.append('state',state);
    formData.append('manager', manager);    
    formData.append('reason', reason);
    formData.append('reason_etc', reason_etc);
    formData.append('return_coupon_count', return_coupon_count);
    formData.append('tmcd', tmcd );
    formData.append('tcid', tcid );
    let result = await axios.post(configState.api + '/gympass_admin/return_edit', formData);
    if(result.data.success!== 1) {
      Swal.fire('오류',result.data.msg);
    }
    setOpenEdit(false);
    load_data(); // 부모창 새로고침
  }

  const onImageChange = e => {
    setFile(e.target.files[0]);
  }

  const load_data1 = async () => {
    const postData = {
      token: get_token(),
      mcd: login.mcd,
      cid: login.cid,
      level: login.level,
      seq: seq,
    }
    let result = await axios.post(configState.api + '/gympass_admin/return_one', postData);
    if (result.data.success === 1) {
      setReason(result.data.row.reason);
      setReasonEtc(result.data.row.reason_etc);
      setImage('/uploads/return/' + ('00000000' + result.data.row.seq).substr(-8, 8) + '_' + result.data.row.mcd + '.jpg');
      setState(result.data.row.state);
      setManager(result.data.row.manager);
      setReturnCouponCount(result.data.row.return_coupon_count); 
      setTmcd(result.data.row.tmcd);      // 2
      setTcid(result.data.row.tcid);
    }
  }

  useEffect(() => {
    if (openEdit) {
      setCoupon({
        seq: 0,
        name: '',
        mcd: ''
      });

      load_data1();
    }
  }, [openEdit]);


  return <>

    {/* 쿠폰찾기팝업 */}
    <RetrunFindCoupon openFindCoupon={openFindCoupon}
      setOpenFindCoupon={setOpenFindCoupon}
      login={login}
      setCoupon={setCoupon}
    ></RetrunFindCoupon>

    <Dialog
      open={openEdit}
      fullWidth={true}
      maxWidth="md"
      TransitionComponent={Transition}
      onClose={() => setOpenEdit(false)}
    >

      <AppBar sx={{ position: "static" }}>
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            <Typography style={{ fontSize: 18 }}>{title}내역 수정</Typography>
          </Box>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => setOpenEdit(false)}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box display="flex" sx={{ p: 1, mt: 2 }}>

        <Box>
          <Box>
            <FormControl sx={{ width: 260 }} size="small">
              <InputLabel>상태</InputLabel>
              <Select
                name="state"
                label="상태"
                onChange={(e) => {
                  setState(e.target.value);
                }}
                value={state}
              >
                <MenuItem value="회원신청">회원신청</MenuItem>
                <MenuItem value="처리완료">처리완료</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ mt: 1 }}>
            <TextField
              name="manager"
              label="담당자"
              size="small"
              sx={{
                width: 260,
              }}
              autoComplete="off"
              value={manager}
              onChange={(e) => setManager(e.target.value)}
            ></TextField>
          </Box>          

          <Box sx={{ mt: 1 }}>
            <FormControl sx={{ width: 260 }} size="small">
              <InputLabel>사유</InputLabel>
              <Select
                name="reason"
                label="사유"
                onChange={(e) => {
                  setReason(e.target.value);
                }}
                value={reason}
              >
                <MenuItem value="코로나">코로나 확진 (본인)</MenuItem>
                <MenuItem value="천재지변">천재지변 (화재, 침수)</MenuItem>
                <MenuItem value="사고및질병">사고 및 질병</MenuItem>
                <MenuItem value="부고">부고 (부모, 형제, 자매)</MenuItem>                
                <MenuItem value="기타">기타</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ mt: 1 }}>
            <TextField
              name="reason_etc"
              label="기타 사유"
              size="small"
              sx={{
                width: 260,
              }}
              autoComplete="off"
              value={reason_etc}
              onChange={(e) => setReasonEtc(e.target.value)}
            ></TextField>
          </Box>

          <Box sx={{ mt: 1 }}>
            <TextField
              name="return_coupon_count"
              label="반환쿠폰 수"
              size="small"
              sx={{
                width: 260,
              }}
              autoComplete="off"
              value={return_coupon_count}
              onChange={(e) => setReturnCouponCount(e.target.value)}
            ></TextField>
          </Box>          

          <Box sx={{ mt: 1 }}>
            <Box sx={{ mt: 1 }}>
              <input accept='image/jpeg' type="file" onChange={onImageChange} />
            </Box>
            {image !== '' &&
              <Box sx={{mt:1}}>
                <a href={image} target="_blank"><img src={image} width="100"></img></a>
              </Box>
            }            
          </Box>

        </Box>

        <Box sx={{ pl: 2 }}>
          <ReturnEditDetail seq={seq} login={login}></ReturnEditDetail>
        </Box>

      </Box>

      <Box>
        <Box
          sx={{
            mt: 2, mb: 3, textAlign: "center"
          }}
        >
          <Button variant="contained" onClick={() => onSubmit()} sx={{ ml:1}}>
            수정완료
          </Button>
          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={() => setOpenEdit(false)}
          >
            취소
          </Button>
        </Box>
      </Box>

    </Dialog >
  </>

}

export default ReturnEdit;